import Router from 'vue-router';

let router = new Router ({
  mode: 'history',
  base: process.env.BASE_URL,

  routes: [
  ]
});

export { router };